  <div class="exit-container dialog-fullscreen" id="exitPage"  *ngIf="showExitConfirmation">
    <div class="error-dialog-box">
      <p class="error-dialog-box-title popup-title">{{ 'exit.exit-message' | translate }}</p>
      <div class="error-dialog-box-buttons exit-box horizontal-focusable-container" data-blocked>
      <span id="exitDescription" *ngIf="enableDescription" style="display: none;">{{ 'exit.exit-message' | translate }}</span>
        <button (click)="ok()" class="primary-button focusable-element" type="button" aria-labelledby="exitDescription yesBtnDescription" (focusout)="onButtonFocus()">
          <span id="yesBtnDescription">{{ 'exit.yes' | translate }}</span>
        </button>
        <button (click)="cancel()" class="primary-button back-btn focusable-element" type="button" aria-labelledby="exitDescription noBtnDescription" (focusout)="onButtonFocus()">
          <span id="noBtnDescription">{{ 'exit.no' | translate }}</span>
        </button>
      </div>
    </div>
</div>
